<template>
    <div class="animated fadeIn">
      <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Billing Status

        <span class="pull-right text-danger font-weight-bold">
          * Agent installation type requires deletion from web to be not charged
        </span>
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Billed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_group">Service</label>
              <br>
              <v-select v-model="so.opt['group.service']" label="name" :options="codes.service_name"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" v-if="!group_id || group_id < 0">
            <b-form-group>
              <label for="opt_groupname">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_groupname" v-model="so.opt['group.groupname']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_billing_email">E-Mail</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_billing_email" v-model="so.opt['email']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
          <b-col sm="2" md="2">
            <b-badge class="mx-2" :variant="codes.variant[index % codes.variant.length]" v-for="(item, index) in summary_data" :key="item.service_name">
              {{item.service_name}} : {{item.total | dollar }}
            </b-badge>
          </b-col>
        <!-- <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable}}
          </b-badge>
        </b-col> -->
        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='group.service';so.skt='Service'; so.sv = '';">Service</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='apply_date';so.skt='Date'; so.sv = '';">Date</b-dropdown-item>
              </b-dropdown>

              <v-select :disabled="so.adv" label="name" v-if="so.sk == 'service'" @change="refresh" v-model="so.sv" :options="codes.service"></v-select>
              <!-- <select  v-model="so.sv"  :option="codes.service">
                <option value="true">Verified</option>
                <option value="false">Not Verified</option>
              </select> -->
            </b-input-group-prepend>
            <b-form-input v-if="so.sk != 'service'" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list_billing" show-empty empty-text="not found"
        :items="getItems" :fields="pay" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="apply_date" slot-scope="row">{{row.item.apply_date.substring(0, 6)}}</template>
        <template slot="group.service" slot-scope="row">
          <b-badge  :variant="row.item.group.service == 'Basic' ? 'info' : 'success'"> {{row.item.group.service}} </b-badge>
          ({{row.item.unit_price | dollar}})
        </template>
        <template slot="group.groupname" slot-scope="row">{{row.item.group.groupname}}</template>
        <template slot="service_unit" slot-scope="row">{{row.item.service_unit.toFixed(2)}}</template>
        <template slot="base_price" slot-scope="row">{{ row.item.base_price | dollar}}</template>
        <template slot="discount_price" slot-scope="row">{{ row.item.discount_price | dollar}}</template>
        <template slot="total_price" slot-scope="row">
          {{row.item.total_price | dollar}}
        </template>
        <template slot="is_paid" slot-scope="row">
          {{row.item.is_paid ? 'Paid' : 'Unpaid'}}
          <span  style="cursor:pointer" v-if="!row.item.is_paid && row.item.history && row.item.history.length && row.item.history.length > 0">
            <b-badge
              variant="primary"
              @click="payment_history(row.item.history, row.item.description)"
            > ? </b-badge>
          </span>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="row.item.is_paid == false" @click="prepayment(row.item)" size="sm" variant="outline-primary">CheckOut</b-btn>
          <b-btn v-if="row.item.is_paid == true" @click="payment_history(row.item.history, row.item.description)" size="sm" variant="outline-primary">Info</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="6">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
        <b-col md="6" v-if="group_id">
          <b-button size="sm" class="float-right" variant="info" @click="confirm_invoice = true"> Invoice Ticket </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- 모달 시작 -->

    <!-- 결제 모달 -->
    <b-modal v-model="confirm_pay" @ok="pay_credit" :header-bg-variant="'danger'">
      Would you like to pay in advance?
      <hr>
      <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
        <b-input v-if="item" v-model="item.total_price"></b-input>
      </b-input-group>
    </b-modal>

    <!-- 결제 모달 -->
    <b-modal v-model="confirm_invoice" @ok="request_billing" header-bg-variant="info">
      When should I issue the bill?
      <hr>
      <date-picker value-type="format" format="YYYY-MM" :lang="custom.lang.en" :first-day-of-week="1" v-model="invoice_ticket" type="month" placeholder="Select month"></date-picker>
      <hr>
      <span v-if="invoice_ticket"> Should I issue a month {{invoice_ticket}} ?</span>
    </b-modal>

    <!-- 결제 히스토리 모달 -->
    <b-modal v-model="history_modal" size="lg" title="Action Information" header-bg-variant="warning">
      <b-table v-if="history_info && history_info.history.length" hover striped small responsive="sm" foot-clone ref="a" show-empty empty-text="There is no payment history!" :items="history_info.history" :fields="pay_history">
        <template slot="action" slot-scope="row">{{row.item.payer ? row.item.purchase_units[0].description : row.item.action}}</template>
        <template slot="pg_name" slot-scope="row">
          {{row.item.payer ? row.item.purchase_units[0].soft_descriptor : row.item.pg_name}}
        </template>
        <template slot="pg" slot-scope="row">{{row.item.payer ? row.item.purchase_units[0].amount.currency_code : row.item.pg}}</template>
        <template slot="price" slot-scope="row">{{row.item.payer ? us.format(row.item.purchase_units[0].amount.value) : us.format(row.item.price)}} </template>
      </b-table>
      <p v-else>{{history_info.description}}</p>
    </b-modal>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import _ from 'lodash';

const usCurrencyFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: 'apply_date', sv: '', skt: 'Date', opt : {}, adv : false
  }
}

export default {
  components: { DatePicker, cSwitch, vSelect },
  name : "BillingList",
  props : ["auto_refresh", "enable_new", "view_detail", "group_id"],
  data: () => ({
    history_modal : false,
    us : usCurrencyFormat,
    history_info : { history : [], description : '' },
    confirm_pay : false,
    confirm_invoice : false,
    invoice_ticket : '',
    custom,
    codes,
    item : {},
    summary_data : [],
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
  }),
  computed: {
    pay() {
      let f = [
        { key: 'apply_date', label: 'Date', sortable: true, thStyle: 'width: 5%' },
        { key: 'group.groupname', label: 'Client', sortable: false, thStyle: 'width: 10%' },
        { key: 'group.service', label: 'Service (A)', sortable: true, thStyle: 'width: 10%' },
        { key: 'service_unit', label: 'Unit (B)', sortable: true, thStyle: 'width: 5%', class: 'text-right' },
        { key: 'base_price', label: 'Amount (AxB)', sortable: true, thStyle: 'width: 10%', class: 'text-right' },
        { key: 'discount_price', label: 'Discount (C)', sortable: true, thStyle: 'width: 10%', class: 'text-right' },
        { key: 'total_price', label: 'Charge Amount(AxB-C)', sortable: true, thStyle: 'width: 10%', class: 'text-right' },
        { key: 'is_paid', label: 'Status', sortable: true, thStyle: 'width: 10%' },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 5%'  },
      ]
      if(this.group_id) { f.splice(1,1) }
      return f
    },
    pay_history() {
      return [
        { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 30%' },
        { key: 'pg_name', label: 'PG-Name', sortable: false, thStyle: 'width: 30%' },
        { key: 'pg', label: 'Method', sortable: false, thStyle: 'width: 10%' },
        { key: 'price', label: 'Price', sortable: false },
      ]
    },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {
    request_billing: function() {
      console.log("start request_billing", this.invoice_ticket)
      Api.Billing_Call('partner', 'admin.service.billing', { group_id : this.group_id, date : this.invoice_ticket }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.$toastr.s("A bill has been issued.")
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    payment_history(item, description){
      this.history_modal = true;
      try { this.history_info.history = _.map(item, r => JSON.parse(r)) } catch (e) { this.history_info.history = []; console.log(e) }
      this.history_info.description = description;
    },
    async pay_credit(){
      let rs = await Api.Partner_Call('group.invoice', 'pay.credit', { id : this.item.id, amount : this.item.total_price })
      if(rs.error) { return this.$toastr.e('pay failed') }
      this.refresh()
    },
    async prepayment(item){
      this.confirm_pay = true;
      this.item = item;
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment();
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      this.$refs._list_billing ? this.$refs._list_billing.refresh() : ''
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      this.invoice_ticket = moment().format('YYYY-MM')
      let and = [{ name : 'partner_id', value : auth.profile.group_id, op : '='} ]
      let so = {
        target : 'group.invoice', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ); }
      if(this.group_id) { so.body.and.push({ name : 'group_id', value : this.group_id, op : '=' } ); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Partner(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      Api.Partner({ target : 'group.invoice', cmd : 'summary', body : { group_id : this.group_id }})
        .then(rs => { this.summary_data = rs.error ? [] : rs.body })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created() { console.log('billing.list.vue', 'created'); },
  destroyed() { console.log('billing.list.vue', 'destroyed'); },
  mounted() { console.log('billing.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
